import React from 'react'

const LinkIconDisable = () => {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 10L10 6"
          stroke="#A6A6A6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33301 3.9976L7.64167 3.64027C8.26688 3.01515 9.1148 2.664 9.99891 2.66406C10.883 2.66413 11.7309 3.0154 12.356 3.6406C12.9811 4.2658 13.3323 5.11373 13.3322 5.99784C13.3321 6.88194 12.9809 7.72982 12.3557 8.35493L11.9997 8.66427"
          stroke="#A6A6A6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66709 12.0026L8.40242 12.3586C7.76992 12.9841 6.91628 13.3349 6.02675 13.3349C5.13723 13.3349 4.28359 12.9841 3.65109 12.3586C3.33932 12.0503 3.09182 11.6833 2.92289 11.2787C2.75397 10.8741 2.66699 10.44 2.66699 10.0016C2.66699 9.56317 2.75397 9.12909 2.92289 8.72451C3.09182 8.31992 3.33932 7.95287 3.65109 7.6446L4.00042 7.33594"
          stroke="#A6A6A6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </React.Fragment>
  )
}

export default LinkIconDisable
